import React, { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const location = useLocation();

    // Close navbar when route changes
    useEffect(() => {
        setIsOpen(false);
        setDropdownOpen(false);
    }, [location]);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleLinkClick = () => {
        setIsOpen(false);
        setDropdownOpen(false);
    };

    const handleDropdownToggle = (e) => {
        e.preventDefault();
        setDropdownOpen(!dropdownOpen);
    };

    return (
      <nav className="navbar navbar-expand-lg navbar-dark bgc-dark sticky-top">
        <a className="navbar-brand ps-5" href="/">
          <img src={require('../../img/Brand.png')} className="d-inline-block align-top brand" alt="OC"></img>
        </a>
        <button 
            className="navbar-toggler" 
            type="button" 
            onClick={handleToggle}
            aria-controls="navbarSupportedContent" 
            aria-expanded={isOpen} 
            aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
          <ul className="navbar-nav me-auto navbar-center ps-5">
            <li className="nav-item dropdown pe-3">
                <a 
                    className="nav-link dropdown-toggle" 
                    href="#"
                    id="navbarDropdown" 
                    role="button" 
                    aria-haspopup="true" 
                    aria-expanded={dropdownOpen}
                    onClick={handleDropdownToggle}
                >
                  Services
                </a>
                <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
                    <NavLink className="dropdown-item" to="/services" onClick={handleLinkClick}>Personal</NavLink>
                    <NavLink className="dropdown-item" to="/comingsoon" onClick={handleLinkClick}>Educational</NavLink>
                    <NavLink className="dropdown-item" to="/comingsoon" onClick={handleLinkClick}>Corporate</NavLink>
                </div>
            </li>
            <li className="nav-item pe-5">
              <NavLink to='/events' className="nav-link single" activeClassName="main-nav-active" onClick={handleLinkClick}>Events</NavLink>
            </li>
            <li className="nav-item pe-5">
                <NavLink to='/retreats' className="nav-link single" activeClassName="main-nav-active" onClick={handleLinkClick}>Retreats</NavLink>
            </li>
            <li className="nav-item pe-5">
                <NavLink to='/shop' className="nav-link single" activeClassName="main-nav-active" onClick={handleLinkClick}>Shop</NavLink>
            </li>
            <li className="nav-item pe-5">
                <NavLink to='/community' className="nav-link" activeClassName="main-nav-active" onClick={handleLinkClick}>Community</NavLink>
            </li>
            <li className="nav-item pe-5">
                <NavLink to='/connect' className="nav-link" activeClassName="main-nav-active" onClick={handleLinkClick}>Connect</NavLink>
            </li>
            <li className="nav-item pe-5">
                <NavLink to='/about' className="nav-link" activeClassName="main-nav-active" onClick={handleLinkClick}>Anca Botez</NavLink>
            </li>
            </ul>
        </div>
      </nav>
    )
}

export default Navbar;
